<template><section><h2>样式调整</h2>
<block-demo tip="" source="const data = [
  { value: 3350, label: &quot;直接访问&quot; },
  { value: 1648, label: &quot;搜索引擎&quot; },
  { value: 2440, label: &quot;联盟广告&quot; },
  { value: 1550, label: &quot;视频广告&quot; },
  { value: 3000, label: &quot;邮件营销&quot; },
]
data.sort((a, b) =&gt; {
  return b.value - a.value
})
const { Chart, Funnel, Tooltip, Legend } = qcharts

const chart = new Chart({
  container: &quot;#app&quot;,
})

chart.source(data, {
  row: &quot;label&quot;,
  value: &quot;value&quot;,
  text: &quot;label&quot;,
})
const tooltip = new Tooltip()
const rightFunnel = new Funnel({
  clientRect: {
    left: &quot;22%&quot;,
    top: &quot;15%&quot;,
    width: &quot;25%&quot;,
    height: &quot;70%&quot;,
  },
  align: &quot;right&quot;,
  pyramid: true,
})
  .style(&quot;guideline&quot;, true)
  .style(&quot;guideText&quot;, true)

const leftFunnel = new Funnel({
  clientRect: {
    left: &quot;50%&quot;,
    top: &quot;15%&quot;,
    width: &quot;25%&quot;,
    height: &quot;70%&quot;,
  },
  align: &quot;left&quot;,
  pyramid: true,
})
  .style(&quot;guideline&quot;, true)
  .style(&quot;guideText&quot;, true)
const legend = new Legend({ align: [&quot;center&quot;, &quot;bottom&quot;] })
chart.append([rightFunnel, leftFunnel, tooltip, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3350</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"直接访问"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1648</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"搜索引擎"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2440</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"联盟广告"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1550</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"视频广告"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3000</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"邮件营销"</span> },
]
data.sort(<span class="hljs-function">(<span class="hljs-params">a, b</span>) =&gt;</span> {
  <span class="hljs-keyword">return</span> b.value - a.value
})
<span class="hljs-keyword">const</span> { Chart, Funnel, Tooltip, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"label"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> rightFunnel = <span class="hljs-keyword">new</span> Funnel({
  <span class="hljs-attr">clientRect</span>: {
    <span class="hljs-attr">left</span>: <span class="hljs-string">"22%"</span>,
    <span class="hljs-attr">top</span>: <span class="hljs-string">"15%"</span>,
    <span class="hljs-attr">width</span>: <span class="hljs-string">"25%"</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-string">"70%"</span>,
  },
  <span class="hljs-attr">align</span>: <span class="hljs-string">"right"</span>,
  <span class="hljs-attr">pyramid</span>: <span class="hljs-literal">true</span>,
})
  .style(<span class="hljs-string">"guideline"</span>, <span class="hljs-literal">true</span>)
  .style(<span class="hljs-string">"guideText"</span>, <span class="hljs-literal">true</span>)

<span class="hljs-keyword">const</span> leftFunnel = <span class="hljs-keyword">new</span> Funnel({
  <span class="hljs-attr">clientRect</span>: {
    <span class="hljs-attr">left</span>: <span class="hljs-string">"50%"</span>,
    <span class="hljs-attr">top</span>: <span class="hljs-string">"15%"</span>,
    <span class="hljs-attr">width</span>: <span class="hljs-string">"25%"</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-string">"70%"</span>,
  },
  <span class="hljs-attr">align</span>: <span class="hljs-string">"left"</span>,
  <span class="hljs-attr">pyramid</span>: <span class="hljs-literal">true</span>,
})
  .style(<span class="hljs-string">"guideline"</span>, <span class="hljs-literal">true</span>)
  .style(<span class="hljs-string">"guideText"</span>, <span class="hljs-literal">true</span>)
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">"center"</span>, <span class="hljs-string">"bottom"</span>] })
chart.append([rightFunnel, leftFunnel, tooltip, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>